import swal from "sweetalert2";
import verification from "../api/verification";
import { handleError } from "./errorHandler";

export const approveVerificationRequest = (
  { verificationId, limitId },
  onSuccess,
) => {
  return swal({
    title: "Are you sure?",
    text: "Do you want to approve this request?",
    type: "warning",
    showCancelButton: true,
    confirmButtonText: "Approve request",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  }).then(result => {
    if (result.value)
      return verification
        .approveVerificationRequest({ verificationId, limitId })
        .then(() => {
          swal("Success", "Verification request approved", "success");
          onSuccess();
        })
        .catch(handleError);
  });
};

export const rejectVerificationRequest = (id, onSuccess) => {
  return swal({
    title: "Are you sure?",
    text: "Do you want to reject this request?",
    type: "warning",
    showCancelButton: true,
    confirmButtonText: "Reject request",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  }).then(result => {
    if (result.value)
      return verification
        .rejectVerificationRequest(id)
        .then(() => {
          swal("Success", "Verification request rejected", "success");
          onSuccess();
        })
        .catch(handleError);
  });
};
